import { connect } from 'react-redux';
import { AuthRoute } from 'react-router-auth';

const mapStateToProps = (state, ownProps) => {
  return {
    authenticated: !!state.authentication.id, 
  }
}

export default connect<any, any, any, any>(mapStateToProps)(AuthRoute)



// WEBPACK FOOTER //
// ./src/components/auth-route.tsx